import { Warning } from "@phosphor-icons/react";
import { flaggedGoods, FLAGGED_GOODS_LABELS } from "../lib/constants";

// Operational Cargo Alert shared across staff (SA/CTRL/CTOP), Rider and Captain surfaces.
// `restrictedGoods` = raw shipment.restricted_goods_declared; only allowed-but-flagged codes render.
// `fragilePackages` = labels of packages with fragile=true (optional; shown where the surface
// supports per-package detail). Renders nothing when neither condition applies.
export function CargoAlert({ restrictedGoods, fragilePackages, className = "", testid = "cargo-alert" }) {
  const flagged = flaggedGoods(restrictedGoods);
  const fragile = Array.isArray(fragilePackages) ? fragilePackages.filter(Boolean) : [];
  if (flagged.length === 0 && fragile.length === 0) return null;
  return (
    <div data-testid={testid} className={`rounded-lg border border-amber-300 bg-amber-50 p-3 ${className}`}>
      <div className="flex items-center gap-2 text-amber-800 font-semibold text-sm">
        <Warning size={16} weight="fill" /> Cargo Alert
      </div>
      {fragile.length > 0 && (
        <div className="mt-2 text-sm text-amber-900" data-testid="cargo-alert-fragile">
          <span className="font-semibold">FRAGILE</span> — handle with care
          <span className="text-amber-700"> · {fragile.join(", ")}</span>
        </div>
      )}
      {flagged.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1.5" data-testid="cargo-alert-flagged">
          {flagged.map((g) => (
            <span
              key={g}
              className="px-2 py-0.5 rounded-full text-xs font-medium bg-amber-200 text-amber-900"
              data-testid={`cargo-alert-good-${g}`}
            >
              {FLAGGED_GOODS_LABELS[g] || g}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default CargoAlert;
